import AlertInterface from '../../alert-interface.js';
import toastr from 'toastr';

toastr.options = {
    "closeButton": true,
    "debug": false,
    "newestOnTop": true,
    "progressBar": true,
    "positionClass": "toastr-bottom-right",
    "preventDuplicates": true,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut",
    "onclick": function(e) {
        var message = $(e.currentTarget).find(".toast-message").text();
        copyToClipboard(message);
    }

};
/**
 * displays toast message and appropriate style/color based on json response code
 * 100 - info
 * 200 - success
 * 300 - warning
 * 400 - danger
 *
 * @link https://github.com/CodeSeven/toastr
 */
class ToastrAlert extends AlertInterface {
    constructor(data) {
        super();

        this.data = data;
    }

    show() {
        switch (this.data.code) {
            case 100:
                toastr.info(this.data.message);
                break;
            case 200:
                toastr.success(this.data.message);
                break;
            case 300:
                toastr.warning(this.data.message);
                break;
            case 400:
                toastr.error(this.data.message);
                break;
        }
    }
}

export default ToastrAlert;
